import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SortConfig } from '../ui-lib/common-table/models/common-table.interface';

@Injectable({
    providedIn: 'root',
})
export class SessionStorageService {
    constructor(private router: Router) {}

    setFiltersValues(formValues: { [key: string]: string | null }): void {
        this.setItem(this.createKey('filters'), formValues);
    }

    getFiltersValues(): { [key: string]: string | null } {
        return JSON.parse(<string>this.getItem(this.createKey('filters')));
    }

    setSortItem(sortConfig: SortConfig): void {
        this.setItem(this.createKey('sort'), sortConfig);
    }

    getSortItem(): SortConfig | undefined {
        return JSON.parse(<string>this.getItem(this.createKey('sort')));
    }

    setColumns(columns: string[]): void {
        this.setItem(this.createKey('columns'), columns);
    }

    getColumns(): string[] | null {
        return JSON.parse(<string>this.getItem(this.createKey('columns')));
    }

    public setItem(key: string, value: unknown): void {
        sessionStorage.setItem(key, JSON.stringify(value));
    }

    public setItemString(key: string, value: string): void {
        sessionStorage.setItem(key, value);
    }

    public getItem(key: string): string | null {
        return sessionStorage.getItem(key);
    }

    public removeItem(key: string): void {
        return sessionStorage.removeItem(key);
    }

    private createKey(key: string): string {
        const routes = this.router.url.split('?')[0].split('/');
        return `${routes.at(-1)}-${key}`;
    }
}
